import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
  const message = String(event?.reason?.message || event?.reason || '');
  if (/Loading chunk [\w-]+ failed/i.test(message) || /Failed to fetch dynamically imported module/i.test(message)) {
    window.location.reload();
  }
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));